module.exports = "/_next/static/images/harajuku_catstreet_lunch-971002cfb3de1c6250e0d32e164cc61b.jpg";